var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "elevation-2",
    class: { "no-show-permission": !_vm.userHasPermissionTo("show") },
    attrs: {
      headers: _vm.headers,
      items: _vm.assetReservationObjects,
      page: _vm.pagination.page,
      loading: _vm.loading,
      "loading-text": "",
      "items-per-page": _vm.paginationReservationObjects.rowsPerPage,
      "items-per-page-text": _vm.rowsPerPageText,
      "items-per-page-items": _vm.rowsPerPageItems,
      "header-props": { sortIcon: _vm.sortIcon },
      "footer-props": {
        prevIcon: _vm.prevIcon,
        nextIcon: _vm.nextIcon,
        "items-per-page-options": _vm.rowsPerPageItems
      }
    },
    on: {
      "update:page": function($event) {
        return _vm.$set(_vm.pagination, "page", $event)
      },
      "update:itemsPerPage": function($event) {
        return _vm.$set(_vm.paginationReservationObjects, "rowsPerPage", $event)
      },
      "update:items-per-page": function($event) {
        return _vm.$set(_vm.paginationReservationObjects, "rowsPerPage", $event)
      },
      pagination: function($event) {
        return _vm.setRowsOnLocalStorage(
          _vm.dataTableReservationListId,
          _vm.paginationReservationObjects.rowsPerPage
        )
      }
    },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function(props) {
          return [
            _c(
              "tr",
              {
                class: {
                  "cursor-pointer":
                    _vm.userHasPermissionTo("show") &&
                    !props.item.aro_is_network_element
                },
                on: {
                  click: function($event) {
                    return _vm.viewItem(props.item)
                  }
                }
              },
              [
                _c(
                  "td",
                  [
                    _c("reservation-state-icon", {
                      attrs: { state: props.item.state }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        props.item.aro_is_network_element
                          ? _vm.$t("No")
                          : _vm.$t("Yes")
                      ) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.getObjectType(props.item)))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(props.item.object_id))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(props.item.object_label))]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    "\n        " +
                      _vm._s(props.item.aro_installation_start_date) +
                      "\n      "
                  )
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(props.item.aro_installation_end_date))])
              ]
            )
          ]
        }
      },
      {
        key: "pageText",
        fn: function(props) {
          return [
            _vm._v(
              "\n    " +
                _vm._s(props.pageStart) +
                " - " +
                _vm._s(props.pageStop) +
                " " +
                _vm._s(_vm.$t("tables.Of")) +
                "\n    " +
                _vm._s(props.itemsLength) +
                "\n  "
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c5409de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c5409de","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssetReservationManagement/Data/ReservationObjectsTable.vue
// module id = null
// module chunks = 